import React from 'react';
import { Card, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import basicCourseImage1 from '../assets/images/1img.jpg'; 
import basicCourseImage2 from '../assets/images/2img.jpg'; 
import basicCourseImage3 from '../assets/images/4img.jpg'; 

const { Meta } = Card;

const Card1 = () => {
  const navigate = useNavigate();

  const handleCardClick = (courseType) => {
    if (courseType === 'short-term-courses') {
      navigate('/short-term-courses');
    } else if (courseType === 'job-oriented-courses') {
      navigate('/job-oriented-courses');
    } else if (courseType === 'customized-training') {
      navigate('/custing');
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Best IT Training Institute in Chennai with Placement Assistance</h1>
      <Row gutter={16} justify="space-evenly">
        <Col xs={24} sm={12} md={8} lg={7}>
          <Card
            hoverable
            style={styles.card}
            cover={<img alt="Short Term Basic Courses" src={basicCourseImage1} style={styles.image} />}
            onClick={() => handleCardClick('short-term-courses')}
          >
            <Meta
              title={<span style={styles.metaTitle}>Short Term Basic Courses</span>}
              description={<span style={styles.metaDescription}>Get ready for the job market!</span>}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={7}>
          <Card
            hoverable
            style={styles.card}
            cover={<img alt="Job Oriented Courses" src={basicCourseImage2} style={styles.image} />}
            onClick={() => handleCardClick('job-oriented-courses')}
          >
            <Meta
              title={<span style={styles.metaTitle}>Job Oriented Courses</span>}
              description={<span style={styles.metaDescription}>Foundation for beginners!</span>}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} md={8} lg={7}>
          <Card
            hoverable
            style={styles.card}
            cover={<img alt="Customized Training" src={basicCourseImage3} style={styles.image} />}
            onClick={() => handleCardClick('customized-training')}
          >
            <Meta
              title={<span style={styles.metaTitle}>Customized Training</span>}
              description={<span style={styles.metaDescription}>Take your skills to the next level!</span>}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

const styles = {
  container: {
    padding: '20px',
    textAlign: 'center',
  },
  title: {
    marginBottom: '10px',
    fontSize: '24px', // Increased font size for the title
    // fontWeight: 'bold',
  },
  card: {
    margin: '10px',
    width: '100%',
  },
  image: {
    height: '450px',
    objectFit: 'cover',
  },
  metaTitle: {
    fontSize: '20px', // Larger font size for card title
    // fontWeight: 'bold',
    marginBottom :'0',
    padding :'0px'
  },
  metaDescription: {
    fontSize: '15px', // Larger font size for card description
    marginTop:'0px'
  },
};

export default Card1;
